/**
 * Local storage prefix to scope all education tooltip related keys.
 *
 * @type {String}
 */
export const STORAGE_PREFIX = 'fiverr_education_tooltips';
